import { createModel } from '@rematch/core';
import { RootModel } from '.';

// Not persisted (see store blacklist): an error must not survive a reload.
type IDefaultState = {
	error?: string;
};

export const app = createModel<RootModel>()({
	state: {
		error: undefined,
	} as IDefaultState,
	reducers: {
		setError(state, error: IDefaultState['error']) {
			return {
				...state,
				error,
			};
		},
	},
});
